import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RpInvoiceComponent } from './rp-invoice/rp-invoice.component';

const routes: Routes = [

  { path: 'invoice', component: RpInvoiceComponent },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class InvoiceRoutingModule { }
